import { TableHeader, TableHeaderProps } from '@design/components/table';

interface HeaderRowProps extends TableHeaderProps {
  labels: string[];
}

export const HeaderRow = ({ labels, ...rest }: HeaderRowProps) => (
  <tr data-testid="header-row">
    {labels.map(label => (
      <TableHeader key={label} isHoverEnabled={false} {...rest}>
        {label}
      </TableHeader>
    ))}
  </tr>
);
